module.exports = __webpack_public_path__ + "static/media/parkpop.686cc3e6.jpg";